module.exports = __webpack_public_path__ + "img/cover_photo.fbb8cf03.jpg";